import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildOpenIndividualNavigation } from '../utils/individualOpenMode';

/**
 * ADR-109 §2 — open an Individual from a report. The entry point's policy
 * (INDIVIDUAL_OPEN_MODE_BY_ENTRY_POINT) decides between the auto route, which resolves
 * Edit/View like the Individuals list, and a read-only open.
 *
 * @returns {(employeeId: string, options: { entryPoint: string, tab?: string, returnTo: string, returnLabel: string, state?: Object }) => void}
 */
const useOpenIndividual = () => {
  const navigate = useNavigate();
  return useCallback((employeeId, options) => {
    const { path, options: navigateOptions } = buildOpenIndividualNavigation({ employeeId, ...options });
    navigate(path, navigateOptions);
  }, [navigate]);
};

export default useOpenIndividual;
